import React, { useCallback, useState } from "react";

import { ReactComponent as CloseIcon } from "../../../../build/images/newTabulationAssets/Button.svg";
import { ReactComponent as CancelIcon } from "../../../../build/images/newTabulationAssets/close-circle.svg";
import { ReactComponent as SaveIcon } from "../../../../build/images/newTabulationAssets/tick-square.svg";

import "./tabulation-modal.css";
import TreeViewCheckbox from "../../../Treeviewcheckbox/TreeViewCheckbox";
import TabulationContainer from "../../../TabulationContainer";
import { useSelectedsTags } from "./hooks/useSelectedsTags";
import Loading from "../../../Loading";
import { InsertTabuladorV2 } from "../../../../actions";
import { toast } from "react-toastify";

const TabulationModal = ({ atdInfo, onClose = () => {} }) => {
  const { tabulatedInfos: Infos, ContactId: Contact, InfoUsers } = atdInfo;
  const {
    tabulatedInfos,
    initialTags,
    isLoading,
    tabulatorOptions,
    defaultChecked,
    selectedsTags,
    tagsSelectedsTorender,
    isSaving,
    text,
    allTagsToRender,
    handleSaveTabulations,
    handleChangeTreeSelect,
    handleChangeText,
    verifyMaxNumberOfSelects,
  } = useSelectedsTags(Contact, onClose, InfoUsers);

  const renderMainContent = () => {
    if (isLoading || isSaving) {
      return <Loading.Paperplane />;
    }

    return (
      <main>
        <section>
          <TreeViewCheckbox
            data={
              tabulatorOptions && tabulatorOptions.three
                ? tabulatorOptions.three
                : []
            }
            notAlloweds={defaultChecked}
            onChange={(nodes) => {
              handleChangeTreeSelect(nodes);
            }}
            verifyMaxNumberOfSelects={verifyMaxNumberOfSelects}
          />
        </section>
        {allTagsToRender.length > 0 && (
          <section>
            <h3>Tags selecionadas</h3>
            <div className="selecteds-tags">
              <TabulationContainer initialTabulationsValue={allTagsToRender} />
            </div>
          </section>
        )}
        <section>
          <h3>Observação</h3>
          <textarea value={text} onChange={handleChangeText} />
        </section>
      </main>
    );
  };
  return (
    <div className="tabulation-modal-container">
      <div className="tabulation-modal-container__content">
        <header>
          <h1>Tabulação</h1>
          <button onClick={onClose}>
            <CloseIcon />
          </button>
        </header>
        {renderMainContent()}
        <footer>
          <div className="tabulation-modal-container__footer-buttons">
            <button
              onClick={() => {
                onClose();
              }}
            >
              <CancelIcon />
              <span>Cancelar</span>
            </button>
            <button
              onClick={() => {
                handleSaveTabulations(
                  selectedsTags,
                  text,
                  InfoUsers,
                  initialTags,
                  tagsSelectedsTorender,
                );
              }}
            >
              <SaveIcon />
              <span>Salvar</span>
            </button>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default TabulationModal;
